import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { Card } from 'antd';
import { LeadCard } from '../LeadCard';
import {
  ColumnContent,
  ExtraContainer,
  ExtraTotalBadge,
  LoadingSkeleton,
  LoadingSkeletonContainer,
} from '../styles';

var ITEM_HEIGHT = 85;
var BUFFER_SIZE = 5;

export var VirtualizedColumn = function(props) {
  var column = props.column;
  var data = props.data;
  var count = props.count;
  var isLoading = props.isLoading;
  var showDrawer = props.showDrawer;

  var containerRef = useRef(null);
  var scrollFrameRef = useRef(null);
  var [scrollTop, setScrollTop] = useState(0);
  var [containerHeight, setContainerHeight] = useState(0);

  useEffect(function() {
    if (containerRef.current) {
      setContainerHeight(containerRef.current.clientHeight);
    }
  }, []);

  // Debounce scroll updates using requestAnimationFrame to reduce re-renders
  var handleScroll = useCallback(function(e) {
    var newScrollTop = e.target.scrollTop;
    if (scrollFrameRef.current) {
      cancelAnimationFrame(scrollFrameRef.current);
    }
    scrollFrameRef.current = requestAnimationFrame(function() {
      setScrollTop(newScrollTop);
    });
  }, []);

  var getVisibleItems = function() {
    if (!containerHeight) return [];

    var startIndex = Math.max(0, Math.floor(scrollTop / ITEM_HEIGHT) - BUFFER_SIZE);
    var endIndex = Math.min(
      data.length,
      Math.ceil((scrollTop + containerHeight) / ITEM_HEIGHT) + BUFFER_SIZE
    );

    return data.slice(startIndex, endIndex).map(function(item, index) {
      return {
        id: item.id,
        name: item.name,
        created_at: item.created_at,
        updated_at: item.updated_at,
        priority: item.priority,
        cadence: item.cadence,
        additional_data: item.additional_data,
        value: item.value,
        icon: item.icon,
        index: startIndex + index
      };
    });
  };

  var visibleItems = getVisibleItems();
  var totalHeight = data.length * ITEM_HEIGHT;

  return (
    <Droppable
      droppableId={`${column.id}`}
      mode="virtual"
      renderClone={(provided, snapshot, rubric) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <LeadCard
            draggableId={data[rubric.source.index].id}
            index={rubric.source.index}
            item={data[rubric.source.index]}
            showDrawer={showDrawer}
            columnId={column.id}
          />
        </div>
      )}
    >
      {(provided) => (
        <Card
          title={column.name}
          bodyStyle={{ padding: 0, minWidth: 300 }}
          headStyle={column.style}
          extra={
            <ExtraContainer>
              <ExtraTotalBadge
                count={count}
                overflowCount={9999}
              />
            </ExtraContainer>
          }
        >
          <ColumnContent
            ref={(el) => {
              provided.innerRef(el);
              containerRef.current = el;
            }}
            style={{ 
              overflowY: 'auto',
              position: 'relative',
              height: '71vh'
            }}
            onScroll={handleScroll}
            {...provided.droppableProps}
          >
            <div
              style={{
                height: totalHeight,
                position: 'relative',
              }}
            >
              {isLoading ? (
                Array(10)
                  .fill(1)
                  .map((_, index) => (
                    <LoadingSkeletonContainer key={index}>
                      <LoadingSkeleton />
                    </LoadingSkeletonContainer>
                  ))
              ) : (
                visibleItems.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      position: 'absolute',
                      top: item.index * ITEM_HEIGHT,
                      width: '100%',
                    }}
                  >
                    <LeadCard
                      draggableId={item.id}
                      index={item.index}
                      item={item}
                      showDrawer={showDrawer}
                      columnId={column.id}
                    />
                  </div>
                ))
              )}
            </div>
            {provided.placeholder}
          </ColumnContent>
        </Card>
      )}
    </Droppable>
  );
}; 